import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  epgData: [],
  lastUpdated: null,
};

// Redux slice
const epgSlice = createSlice({
  name: "epg",
  initialState,
  reducers: {
    setEpgData(state, action) {
      state.epgData = action.payload.epgData;
      state.lastUpdated = action.payload.lastUpdated;
    },
    clearEpgData(state) {
      state.epgData = [];
      state.lastUpdated = null;
    },
  },
});

export const { setEpgData, clearEpgData } = epgSlice.actions;
export default epgSlice.reducer;

// Async function to fetch and process EPG data
export const fetchEpgData = (epgUrl) => async (dispatch) => {
  try {
    const response = await fetch(epgUrl);
    const text = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(text, "application/xml");

    const epgData = [];
    const programmes = xmlDoc.getElementsByTagName("programme");

    for (let i = 0; i < programmes.length; i++) {
      const programme = programmes[i];
      const id = programme.getAttribute("channel");
      // Manually parse the start and stop times
      const rawStart = programme.getAttribute("start");
      const rawStop = programme.getAttribute("stop");

      const start = parseEpgDate(rawStart);
      const stop = parseEpgDate(rawStop);
      const title = programme.getElementsByTagName("title")[0].textContent;
      const description = programme.getElementsByTagName("desc")[0].textContent;

      epgData.push({
        id,
        start,
        stop,
        title,
        description,
      });
    }
    dispatch(setEpgData({ epgData, lastUpdated: Date.now() }));
  } catch (error) {
    console.error("Failed to fetch EPG data", error);
  }
};

const parseEpgDate = (dateString) => {
  // Example input: "20240829083000 +0000"
  // Split the date string into components
  const datePart = dateString.slice(0, 8); // "20240829"
  const timePart = dateString.slice(8, 14); // "083000"
  const timeZonePart = dateString.slice(15); // "+0000"

  // Format the date and time parts into a standard ISO string
  const formattedDateString = `${datePart.slice(0, 4)}-${datePart.slice(
    4,
    6
  )}-${datePart.slice(6, 8)}T${timePart.slice(0, 2)}:${timePart.slice(
    2,
    4
  )}:${timePart.slice(4, 6)}${timeZonePart.slice(0, 3)}:${timeZonePart.slice(
    3
  )}`;

  // Parse the formatted date string
  const parsedTime = Date.parse(formattedDateString);

  if (isNaN(parsedTime)) {
    console.error(`Failed to parse date: ${dateString}`);
  }

  return parsedTime;
};
